module.exports = __webpack_public_path__ + "img/profile-button-silver.b026c220.svg";